<template>
  <div dir="rtl" class="modal fade" id="retrieve-device-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered" style="max-width: 500px">
      <div class="modal-content p-3">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title">
            {{ step === 1 ? "استعادة جهازي" : "تأكيد الرمز" }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- الصورة -->
          <div class="text-center mb-3">
            <img src="assets/img/mobile.png" style="width: 135px" />
          </div>

          <!-- رسالة النجاح -->
          <p v-if="successMessage" class="text-center text-success fw-bold">
            {{ successMessage }}
          </p>

          <p v-if="step === 1" class="text-center bg-light p-2 rounded">
            أدخل رقم الهاتف لاستعادة جهازك
          </p>

          <p v-else class="text-center bg-light p-2 rounded">أدخل رمز التحقق الذي وصلك</p>

          <!-- خطوة إدخال رقم الهاتف -->
          <div v-if="step === 1">
            <div class="form-group mb-3">
              <label>رقم الهاتف</label>
              <input
                id="devicePhone"
                type="tel"
                class="form-control"
                dir="ltr"
                style="padding-right: 0px"
              />
            </div>

            <!-- اختيار وسيلة الإرسال -->
            <div class="form-group mb-3">
              <label class="mb-1 d-block fw-bold">طريقة الإرسال</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method_sms"
                  value="sms"
                  v-model="selectedMethod"
                />
                <label class="form-check-label" for="method_sms">رسالة نصية (SMS)</label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method_whatsapp"
                  value="whatsapp"
                  v-model="selectedMethod"
                />
                <label class="form-check-label" for="method_whatsapp">واتساب</label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method_email"
                  value="email"
                  v-model="selectedMethod"
                />
                <label class="form-check-label" for="method_email">البريد الكتروني</label>
              </div>
            </div>

            <small v-if="errorMessage" class="text-danger">{{ errorMessage }}</small>

            <button
              class="btn btn-success w-100"
              :disabled="isLoading"
              @click="sendPhone"
            >
              {{ isLoading ? "جاري الإرسال..." : "إرسال الرمز" }}
            </button>
          </div>

          <!-- خطوة إدخال OTP -->
          <div v-else>
            <div class="form-group mb-3">
              <label>رمز التحقق (OTP)</label>
              <input
                v-model="otp"
                type="text"
                class="form-control"
                placeholder="أدخل الرمز"
              />
            </div>

            <small v-if="errorMessage" class="text-danger d-block mb-2">{{
              errorMessage
            }}</small>

            <div class="d-flex gap-2">
              <button
                class="btn btn-secondary w-50"
                :disabled="isLoading"
                @click="goBack"
              >
                رجوع
              </button>
              <button
                class="btn btn-success w-50"
                :disabled="isLoading"
                @click="verifyOtp"
              >
                {{ isLoading ? "جاري الاستعادة..." : "استعادة الجهاز" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

var itiDevice;

export default {
  data() {
    return {
      step: 1,
      otp: "",
      isLoading: false,
      errorMessage: "",
      successMessage: "",
      selectedMethod: "sms", // default
    };
  },
  mounted() {
    const modal = document.getElementById("retrieve-device-modal");
    const phone = document.getElementById("devicePhone");

    modal.addEventListener("shown.bs.modal", () => {
      itiDevice = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly",
        separateDialCode: true,
        excludeCountries: ["il"],
      });
    });
  },
  methods: {
    goBack() {
      this.errorMessage = "";
      this.successMessage = "";
      this.otp = "";
      this.step = 1;
      this.selectedMethod = "sms";
      this.$nextTick(() => {
        const phone = document.getElementById("devicePhone");
        itiDevice = intlTelInput(phone, {
          utilsScript: "assets/js/utils.js",
          initialCountry: "ly",
          separateDialCode: true,
          excludeCountries: ["il"],
        });
      });
    },

    async sendPhone() {
      this.errorMessage = "";
      this.successMessage = "";
      try {
        this.isLoading = true;
        const phoneNumber = itiDevice.getNumber();

        const payload = {
          phone: phoneNumber,
          country_code: "+" + itiDevice.getSelectedCountryData().dialCode,

          sms: this.selectedMethod === "sms" ? 1 : 0,
          whatsapp: this.selectedMethod === "whatsapp" ? 1 : 0,
          email: this.selectedMethod === "email" ? 1 : 0,
        };

        const res = await fetch(`${apiUrl}/lost-master-device`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || "حدث خطأ أثناء الإرسال");
        }

        this.successMessage = "تم إرسال الرمز إلى رقمك";
        this.step = 2;
      } catch (err) {
        this.errorMessage = err.message || "حدث خطأ أثناء الإرسال";
      } finally {
        this.isLoading = false;
      }
    },

    async verifyOtp() {
      this.errorMessage = "";
      if (!this.otp) {
        this.errorMessage = "يرجى إدخال رمز التحقق";
        return;
      }
      this.isLoading = true;
      try {
        const res = await fetch(`${apiUrl}/retrieve-master-device`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ otp: this.otp }),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || "حدث خطأ أثناء التحقق");
        }

        Swal.fire("تمت الاستعادة", "تم استعادة جهازك بنجاح", "success");
        this.goBack();
      } catch (err) {
        this.errorMessage = err.message || "حدث خطأ أثناء التحقق";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 12px;
}
.form-group label {
  font-weight: 700;
  margin-bottom: 8px;
}
.btn {
  padding: 10px;
  font-weight: bold;
}
</style>
